import React, { Component } from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Button from 'material-ui/Button'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import UploadFiber from './upload'

import {
  dateTimeFormatter
} from '../../../common/utils'

class SettingsFiberlimits extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false
    }
    this.handleClose = this.handleClose.bind(this)
  }
  showModal(e) {
    this.setState({
      modal: true
    })
  }
  handleClose(e) {
    this.setState({
      modal: false
    })
  }
  render() {
    const { classes, translate, uploadFiberFilesDb, log } = this.props
    const { modal } = this.state

    let $modal = modal ? (
      <UploadFiber
        translate={translate}
        onClose={this.handleClose}
        uploadFiberFilesDb={uploadFiberFilesDb}
      />
    ) : (null)
    return (
      <div>
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12}>
              <Typography type="headline" color="inherit">
                {translate("settings_lt4_fiber_limit")}
              </Typography>
            </Grid>
            <Grid item xs={12} className={classes.info}>
              <Typography type="subheading" color="inherit">
                {translate("settings_fiber_limitsdb_label")}
              </Typography>
              <Typography type="caption" color="inherit" className={classes.uppercase}>
                {translate("settings_current_version")} <b>{(log && log.cometfiberlimitparser) ? log.cometfiberlimitparser.name : ''}</b>
              </Typography>
              <Typography type="caption" color="inherit" className={classes.uppercase}>
                {translate("settings_date_uploaded")} <b>{(log && log.cometfiberlimitparser) ? dateTimeFormatter(log.cometfiberlimitparser.createdat) : ''}</b>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
              className={classes.orangeButton}
                fullWidth
                raised
                onClick={(e) => this.showModal(e)}
              >{translate("settings_upload")}</Button>
            </Grid>
          </Grid>
        </Paper>
        {$modal}
      </div>

    )
  }

}

export default withStyles(styles)(SettingsFiberlimits)
